'use client';
export { Box } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map